<template>
  <v-row>
    <v-col>
      <v-alert
        class="mb-3"
        type="warning"
        color="deep-orange"
        prominent
        v-if="
          isAuthenticated &&
          (user.birthday.length < 10 ||
            isNaN(new Date(user.birthday)) ||
            !user.city)
        "
      >
        Viemos informar que o cadastro de seu usuário precisa ser atualizado.
        Por favor, para atualizar suas informações
        <router-link to="/atualizar-conta"> clique aqui. </router-link>
      </v-alert>

      <v-card>
        <v-card-text class="pa-0">
          <div class="pt-4 px-6 text-body-2">
            <p v-if="isAuthenticated">
              Olá,
              <strong>{{
                user.usar_nome_social ? user.social_name : user.name
              }}</strong
              >.
            </p>
            <p>
              Seja bem vindo ao sistema de processos seletivos e concursos da
              Universidade Federal do Amapá.
            </p>
            <p v-if="!isAuthenticated" class="mt-4">
              Caso queira entrar no sistema,
              <router-link to="/entrar"> clique aqui. </router-link>
              <br />
              Ou se ainda não possui conta,
              <router-link to="/nova-conta"> clique aqui. </router-link>
            </p>
          </div>

          <v-expansion-panels flat v-model="panels" multiple class="mt-n4 pb-2">
            <v-expansion-panel v-if="isAuthenticated">
              <v-expansion-panel-header class="font-weight-medium">
                Meus concursos
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap v-if="meusConcursos.length > 0">
                  <v-flex d-flex flex-wrap bg-surface-variant>
                    <v-card
                      outlined
                      v-for="(item, i) in meusConcursos"
                      :key="i"
                      class="ma-2 pa-2"
                      :width="
                        $vuetify.breakpoint.name === 'xs' ? '100%' : '300'
                      "
                      height="180"
                    >
                      <v-card-title style="word-break: break-word">
                        <span class="text-subtitle-2 font-weight-medium">
                          {{ item.title }}
                        </span>
                      </v-card-title>

                      <v-card-actions>
                        <v-btn
                          elevation="0"
                          absolute
                          bottom
                          left
                          color="green"
                          dark
                          @click="$router.push(`${item.to}/minha-inscricao/`)"
                          >Minha Inscrição</v-btn
                        >

                        <v-btn
                          absolute
                          bottom
                          right
                          color="primary"
                          elevation="0"
                          @click="$router.push(item.to)"
                          >Ver edital</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
                <span v-else>Você ainda não se inscreveu em nenhum edital</span>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header class="font-weight-medium">
                Concursos em andamento
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap v-if="concursos.length > 0">
                  <v-flex d-flex flex-wrap bg-surface-variant>
                    <v-card
                      outlined
                      v-for="(item, i) in concursos"
                      :key="i"
                      class="ma-2 pa-2"
                      :width="
                        $vuetify.breakpoint.name === 'xs' ? '100%' : '300'
                      "
                      height="180"
                    >
                      <v-card-title style="word-break: break-word">
                        <span class="text-subtitle-2 font-weight-medium">
                          {{ item.title }}
                        </span>
                      </v-card-title>
                      <v-card-actions>
                        {{ item.links }}
                        <v-btn
                          absolute
                          bottom
                          right
                          color="primary"
                          elevation="0"
                          @click="$router.push(item.to)"
                          >Ver edital</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
                <span v-else>Não existem editais em andamento</span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
      <LoadingDialog :loading="loading" />
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import LoadingDialog from "@/components/LoadingDialog.vue";

export default {
  metaInfo: {
    title: "Principal",
  },
  data() {
    return {
      loading: true,
      panels: [0, 1],
    };
  },
  components: {
    LoadingDialog,
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("concursos", ["concursos", "meusConcursos"]),
    ...mapState("auth", ["user", "token"]),
  },

  async created() {
    this.loading = true;
    // if (this.token && (!this.concursos || !this.concursos.length)) {
    //   await this.fetchConcursos();
    // }
    this.loading = false;
  },
  methods: {
    ...mapActions("concursos", ["fetchConcursos"]),
  },
};
</script>
